export default function () {
  return !this.node();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/empty.js
// module id = 437
// module chunks = 0